import React, { useCallback, useEffect, useState } from 'react'
import { CSmartTable } from '@coreui/react-pro'
import debounce from 'lodash.debounce'
import moment from 'moment'
import EmailQuotaService from 'src/service/EmailQuotaService'

const FantasyRoundEmailLog = ({ emailType }) => {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [columnFilter, setColumnFilter] = useState({})
  const [columnSorter, setColumnSorter] = useState({})

  const columns = [
    {
      label: 'SN',
      key: 'sn',
    },
    {
      label: 'Send Date',
      key: 'created_at_date',
    },
    {
      label: 'Send Time',
      key: 'created_at_time',
    },
    {
      label: 'Emails Sent',
      key: 'email_count',
    },
  ]

  const fetchUsers = useCallback(
    debounce(async () => {
      try {
        setLoading(true)
        const offset = itemsPerPage * (activePage - 1)
        const params = new URLSearchParams()

        Object.entries(columnFilter).forEach(([key, value]) => {
          if (value) params.append(key, value) // Avoid appending empty values
        })

        if (columnSorter?.column) {
          params.append('sort', `${columnSorter.column}%${columnSorter.state}`)
        }

        const result = await EmailQuotaService.getEmailLogs(
          emailType,
          offset,
          itemsPerPage,
          activePage,
          params,
        )

        setUsers(result.data)
      } catch (error) {
        console.error('Error fetching email logs:', error)
      } finally {
        setLoading(false)
      }
    }, 500), // Debounce to prevent multiple API calls on repeated clicks
    [emailType, activePage, itemsPerPage, columnFilter, columnSorter],
  )

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])

  return (
    <>
      <CSmartTable
        columns={columns}
        columnFilter={{
          external: true,
        }}
        columnSorter={{
          external: true,
        }}
        scopedColumns={{
          sn: (item, index) => <td>{index + 1}</td>,
          created_at_date: (item) => <td>{moment(item.created_at).format('D.MM.YYYY')}</td>,
          created_at_time: (item) => <td>{moment(item.created_at, ['HH:mm']).format('h:mma')}</td>,
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading}
        pagination={{
          external: true,
        }}
        paginationProps={{
          activePage: activePage,
          pages: Math.ceil(users?.total / itemsPerPage) || 1,
        }}
        tableProps={{
          hover: true,
          responsive: true,
        }}
        onActivePageChange={(activePage) => setActivePage(activePage)}
        onColumnFilterChange={(filter) => {
          setActivePage(1)
          setColumnFilter(filter)
        }}
        onItemsPerPageChange={(itemsPerPage) => {
          setActivePage(1)
          setItemsPerPage(itemsPerPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
    </>
  )
}

export default FantasyRoundEmailLog
